import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Button, Form, Row, Col, Table, Card, InputGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';
import Separator from '../helper/Separator';
import { getCurrencyFormatter, formatDate } from '../helper/DateTimeFormater';


function UpgradeAbo() {
    const { request } = useRequest();

    const [curAbo, setCurAbo] = useState({});
    const [abos, setAbos] = useState([]);
    const [step, setStep] = useState(0);

    const [presetNames, setPresetNames] = useState(null);

    const [selectedAbo, setSelectedAbo] = useState({});

    const [data, setData] = useState({});

    const formRef = useRef(null);

    const cFormatter = getCurrencyFormatter();

    const setAbo = async (index) => {
        setData(data => { return { ...data, abo: index } });
        let result = await request("/Business/GetNewAboDates", { period: abos[index - 1].Period });
        let json = result.data;
        if (json.r != 1) {
            if (json.message) {
                alert.error(json.message);
            }
            else {
                alert.error("Es ist ein Fehler aufgetreten.");
            }
        }
        else {
            setCurAbo(json.abo);
        }
        setStep(1);
        document.getElementById("content").scrollIntoView();
    }

    const handleUpgradeAbo = async (values) => {
        const result = await request("/Business/UpgradeAbo", {curAbo: selectedAbo, newAbo: values});
        const json = result.data;

        if (json.r == 1) {
            window.location.replace("/Business/Abo");
        }
        else {
            toast.error(json.message);
            setStep(0);
        }
    };

   

    const checkAboTier = () => {
        for (let i = 0; i < abos.length; i++) {
            if (selectedAbo.Name == abos[i].Name) {
                return i;
            }
        }
        return 0;
    }

    const calcTotal = (newAbo, curAbo = selectedAbo) => {
        let oneDay = 24 * 60 * 60 * 1000; //stunden * minuten * sekunden * millisekunden
        let curAboStart = new Date(curAbo.Start);
        let curAboEnd = new Date(curAbo.End);
        let newAboEnd = new Date(curAbo.Start);
        newAboEnd.setMonth(newAboEnd.getMonth() + newAbo.Period)
        let curAboDays = Math.round((curAboEnd - curAboStart) / oneDay);
        let newAboDays = Math.round((newAboEnd - curAboStart) / oneDay);
        let pastDays = Math.round((new Date() - curAboStart) / oneDay);
        let total = 0.00;
        if (pastDays > 0) {
            let curPricePerDay = (curAbo.Price / curAboDays).toFixed(2);
            let newPricePerDay = ((newAbo.Price * newAbo.Period) / newAboDays).toFixed(2);
            total = ((curPricePerDay * pastDays) + (newPricePerDay * (newAboDays - pastDays))).toFixed(2);
        }
        else total =  (newAbo.Price * newAbo.Period).toFixed(2);
        return total
    }

    const back = () => {
        setStep(step => Math.max(0, Math.min(step - 1, 4)));
        document.getElementById("content").scrollIntoView();
    }


    useEffect(() => {
        const getPresets = async () => {
            try {
                let result = await request("/Business/GetSubscriptionPresets");
                let json = result.data;
                if (json.r != 1) {
                    if (json.message) {
                        toast.error(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten.");
                    }
                }
                else {
                    const head = json.abos.shift(); //Removes Schnupper-Abo
                    setAbos(json.abos);
                }
            }
            catch {
                toast.error("Fehler beim Laden");
            }
        };
        const getSelectedAbo = async () => {
            let pathname = location.pathname.split("/");
            let id = pathname[pathname.length - 1];
            let result = await request("/Business/GetAboById", { aboId: id });
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten.");
                }
            }
            else {
                setSelectedAbo(json.abo);
            }
        }
        getSelectedAbo();
        getPresets();
    }, []);

    useEffect(() => {
        var names = [];
        for (var i = 0; i < abos.length; i++) {
            names.push(<th className="level-1 text-center border-top-0">{abos[i].Name}</th>);
        }
        setPresetNames(names);
    }, [abos]);
    if (step == 0) {
        return (
            <>
                <Separator text="Paketauswahl" />
                <p>Bitte wählen Sie Ihr gewünschtes Paket aus.</p>
                <p>Entspricht keins der oberen Pakete Ihren Ansprüchen? Dann kontaktieren Sie uns gerne per E-Mail.</p>
                <Table>
                    <thead>
                        <tr>
                            <th className="level-0 border-top-0">Pakete</th>
                            {abos.map(i => <th key={i.AboID} className="level-1 text-center border-top-0">{i.Name}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="level-0">Laufzeit</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{i.Period} Monate</td>)}
                        </tr>
                        <tr>
                            <td className="level-0">Mögliche Termine pro Monat</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{i.Contingent / i.Period}</td>)}
                        </tr>
                        <tr>
                            <td className="level-0">Anzahl Benutzer</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{i.User}</td>)}
                        </tr>
                        <tr>
                            <td className="level-0">Anzahl Referenten</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{i.Contactperson > 999 ? "Unbegrenzt" : i.Contactperson}</td>)}
                        </tr>
                        <tr>
                            <td className="level-0">Umkreis (PLZ Standort)</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{i.Radius > 300 ? "deutschlandweit" : i.Radius + " km"}</td>)}
                        </tr>
                        <tr>
                            <td className="level-0">Support (Hotline/Email)</td>
                            {abos.map((a, i) => <td key={a.AboID} className={"level-" + i + " text-center"}>Inklusive</td>)}

                        </tr>
                        <tr>
                            <td className="level-0">Preis pro Monat (exkl. MwSt)</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{cFormatter.format(i.Price)}</td>)}
                        </tr>
                        <tr className="book">
                            <td className="level-0"></td>
                            {abos.map((a, i) => <td key={a.AboID} className={"level-" + i + " text-center"}><button className="btn btn-secondary" disabled={checkAboTier() >= i} onClick={() => setAbo(i+1)}>Auswählen</button></td>)}

                        </tr>

                    </tbody>
                </Table>
               
                <div>
                    <Button type="button" variant="primary" onClick={() => location.pathname = "/Business/Abo"}><i className="fa-solid fa-chevron-left mr-2"></i>Zurück</Button>
                </div>
            </>
        );
    }
    if (step == 1) {
        const selectedAbo = abos.find(m => m.AboID == data.abo);
        if (!selectedAbo) selectedAbo = {};

        return (
            <Formik
                innerRef={(f) => formRef.current = f}
                validateOnChange={true}
                validateOnBlur={true}
                onSubmit={(values) => {
                    handleUpgradeAbo(values);
                }}
                initialValues={selectedAbo}
            >
                {({
                    handleSubmit,
                }) => {

                    return (
                        <Form noValidate onSubmit={handleSubmit} className="mt-3">
                            <Separator text="Zusammenfassung" />
                            <Row className="mb-3">
                                <Col sm={12} lg={6}>
                                    <Card>
                                        <Card.Header>Ausgewähltes Paket</Card.Header>
                                        <Card.Body className="py-2">
                                            <Table size="sm" className="mb-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="border-top-0">Paketname</td>
                                                        <td className="text-right border-top-0">
                                                            {selectedAbo.Name}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Termine pro Monat</td>
                                                        <td className="text-right">
                                                            {selectedAbo.Contingent / selectedAbo.Period}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Paketlaufzeit</td>
                                                        <td className="text-right">
                                                            {selectedAbo.Period} Monate
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Preis pro Monat (exkl. MwSt)</td>
                                                        <td className="text-right">
                                                            {cFormatter.format(selectedAbo.Price)}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Preis Gesamt (exkl. MwSt)</td>
                                                        <td className="text-right">
                                                            {cFormatter.format(calcTotal(selectedAbo))}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Start</td>
                                                        <td className="text-right">
                                                            {formatDate(curAbo.Start)}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Ende</td>
                                                        <td className="text-right">
                                                            {formatDate(curAbo.End)}
                                                        </td>
                                                    </tr>
                                                   
                                                </tbody>
                                            </Table>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Button type="button" variant="primary" onClick={() => back()}><i className="fa-solid fa-chevron-left mr-2"></i>Zurück</Button>
                                </Col>
                                <Col xs={6} className="text-right">
                                    <Button type="submit" variant="secondary"><i className="fa-solid fa-right-to-bracket mr-2"></i>Buchung bestätigen</Button>
                                </Col>
                            </Row>
                        </Form>
                    )
                }}
            </Formik>
        );
    }
}

export default UpgradeAbo;